import {createFileRoute} from '@tanstack/react-router';

import {AdminLayout} from '@/modules/admin/components/AdminLayout';

export const Route = createFileRoute('/_authenticated/admin')({
  component: AdminLayout,
});
